import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const HeroStyles = styled.div`
  height: 160px;

  .hero-banner {
    align-items: center;
    background-color: ${Colors.primary.claytonBlue.standard};
    display: flex;
    left: 0;
    justify-content: center;
    height: 160px;
    margin-top: -25px;
    position: absolute;
    width: 100%;

    h1 {
      color: ${Colors.primary.white.standard};
      font-size: 40px;
    }
  }
`;
